import { application } from '../../../_runtime/bootstrap';
import { FormikContextType } from 'formik';

/**
 * Function: mapSpaceParameters
 * 
 * This function maps space parameters and updates the Formik form state with the new parameters.
 * It fetches the parameters for the "SPACES" category and, if the form is in edit mode,
 * also fetches the existing parameters for the specified element ID. It then combines the two
 * sets of parameters and updates the Formik form state with the new parameters.
 * 
 * @param {FormikContextType<any>} formik - The Formik form context.
 * @param {Function} setLoading - Function to set the loading state.
 * @param {Function} setOverridenParameters - Function to set the overridden parameters state.
 * @param {boolean} isEditForm - Flag to indicate if the form is in edit mode.
 * 
 * @returns {Promise<void>} A promise that resolves when the parameters have been mapped and the form state updated.
 */
export const mapSpaceParameters = async (
  formik: FormikContextType<any>,
  setLoading: any,
  setOverridenParameters: any,
  isEditForm: boolean
) => {
  const componentParameters = await application
    .getHttpClient()
    .get(`/buildingms/categories/parameters?category=SPACES`)
    .then((response: any) => {
      return response.body!.items;
    });
  let existentTypeParameters: any[] = [];

  if (isEditForm) {
    existentTypeParameters = await application
      .getHttpClient()
      .get(`/buildingms/types/parameters?elementId=${formik.values.id}`)
      .then((response: any) => {
        setOverridenParameters(response.body!.items);
        return response.body!.items;
      });
  }

  const newComponentParameters = componentParameters.map((param: any) => {
    const typeParam = existentTypeParameters.find(
      (typeParam: any) => typeParam.parameterId === param.id
    );
    let newParam: any = {
      id: param.id,
      name: param.name,
      description: param.description,
      defaultValue: param.value,
      category: param.category,
      type: param.type,
    };

    if (typeParam) {
      newParam = {
        ...newParam,
        value: typeParam.value,
      };
    }

    return newParam;
  });

  formik.setFieldValue('typeParameters', newComponentParameters);
  setLoading(false);
};
